import Icon from '../components/Icon.vue'

Icon.register({
  torah: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M320.1 366.5l-17.7-29.6h35.5zM419.3 200.5l-18.4 30.8-18.5-30.8h36.9zM48 0c26.5 0 48 14.3 48 32v448c0 17.7-21.5 32-48 32s-48-14.3-48-32v-448c0-17.7 21.5-32 48-32zM220.7 311.5l18.4-30.8 18.5 30.8h-36.8zM382.4 311.5l18.4-30.8 18.4 30.8h-36.9zM128 464v-416h384v416h-384zM194.8 185.9c-1.5 2.7-2.8 7.3-2.8 10.4 0 3.2 1.4 8 3 10.8l29.4 49-29.2 48.8c-1.7 2.8-3 7.7-3 10.9 0 11.7 9.5 21.1 21.1 21.1h0 59.5l29.3 48.9c3.3 5.6 11.4 10.2 17.9 10.2h0.1c6.6 0 14.8-4.7 18.2-10.4l29.1-48.7h59.5 0c6.8 0 15.1-4.8 18.5-10.7 1.5-2.7 2.8-7.3 2.8-10.4 0-3.2-1.4-8-3-10.8l-29.4-49 29.2-48.8c1.7-2.8 3-7.6 3-10.9 0-11.7-9.5-21.1-21.1-21.1h-59.5l-29.3-48.9c-3.3-5.6-11.3-10.2-17.9-10.2h-0.1 0c-6.7 0-14.8 4.6-18.2 10.4l-29.1 48.7h-59.5 0c-6.8 0-15.1 4.8-18.4 10.7zM592 0c26.5 0 48 14.3 48 32v448c0 17.7-21.5 32-48 32s-48-14.3-48-32v-448c0-17.7 21.5-32 48-32zM320 145.5l17.7 29.6h-35.5zM257.6 200.5l-18.4 30.8-18.4-30.8h36.8zM287.1 311.5l-33.2-55.5 33.2-55.5h65.8l33.2 55.5-33.2 55.5h-65.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/torah.js
// module id = 2022
// module chunks = 0